<template>
    <div>
        <modal class="ml-3" container-style="width: 445px; height: 530px;" v-model="modalOpen" :hideCloseButton="true">
            <div class="product-accessories-popup" v-if="accessories">
                <div class="mb-4 px-0">
                    <h2 class="level-one-heading">Har du allt du behöver?</h2>
                    <p class="text-secondary">Rekommenderade tillbehör</p>
                    <product-tip-slider
                        :products="accessories"
                        :compact="true"
                        :showBuyBtn="true"
                        :loop="false"
                        :showProgressBar="true"
                        :showProductBorder="false"
                        parentElement="Product accessory popup"
                    />
                </div>
                <br>
                <div class="add-insurance">
                    <text-button
                        text="Behövs inte. Jag har allt nu!"
                        variant="secondary"
                        width="wide"
                        center="center"
                        @click="bus.$emit('modal.close')"
                    />
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import bus from 'eventbus';

export default {
    props: {
        accessories: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            bus,
            modalOpen: false,
        }
    }
}
</script>